import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, CreditCard, CalendarCheck, Users, Sparkles, Clock, MessageCircle, ChevronRight } from "lucide-react";
import { api, fmtDateTime } from "../lib/api";
import { Screen, PageHeader, Empty } from "../components/ui-kit";

const ICONS = { payment: CreditCard, booking: CalendarCheck, event: Sparkles, friend: Users, reminder: Clock, message: MessageCircle, info: Bell };
const LINK_BY_KIND = { payment: "/wallet", booking: "/", reminder: "/", event: "/", friend: "/friends", message: "/messages", info: "/" };

export default function Notifications() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [unreadOnly, setUnreadOnly] = useState(false);

  useEffect(() => {
    api.get("/notifications").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  const open = (n) => {
    if (!n.read) { api.post(`/notifications/${n.id}/read`).catch(() => {}); setItems((prev) => prev.map((x) => (x.id === n.id ? { ...x, read: true } : x))); }
    navigate(n.link || LINK_BY_KIND[n.kind] || "/");
  };

  const readAll = async () => {
    setItems((prev) => prev.map((x) => ({ ...x, read: true })));
    await api.post("/notifications/read-all").catch(() => {});
  };

  const unreadCount = items.filter((n) => !n.read).length;
  const shown = unreadOnly ? items.filter((n) => !n.read) : items;

  return (
    <Screen>
      <PageHeader overline="Updates" title="Notifications" back />
      <div className="flex items-center gap-2 mb-4">
        <button onClick={() => setUnreadOnly((v) => !v)} data-testid="notif-unread-toggle" className={`rounded-full px-4 py-1.5 text-sm border transition-colors ${unreadOnly ? "bg-[#D4AF37] text-black border-[#D4AF37]" : "bg-white/5 border-white/10 text-[#E8E4F0]"}`}>{unreadOnly ? "Showing unread" : "Show unread only"}</button>
        {unreadCount > 0 && <button onClick={readAll} data-testid="notif-read-all" className="ml-auto rounded-full px-4 py-1.5 text-sm bg-white/5 border border-white/10 text-[#D4AF37]">Read all ({unreadCount})</button>}
      </div>
      {shown.length === 0 ? (
        <Empty icon={Bell} text={unreadOnly ? "No unread notifications." : "No notifications yet."} />
      ) : (
        <div className="space-y-3">
          {shown.map((n) => {
            const Icon = ICONS[n.kind] || Bell;
            return (
              <button key={n.id} data-testid="notification-item" onClick={() => open(n)}
                className={`w-full text-left flex gap-4 items-center rounded-2xl border p-4 active:scale-[0.99] transition-transform hover:brightness-110 ${n.read ? "bg-white/5 border-white/10" : "bg-[#D4AF37]/[0.07] border-[#D4AF37]/25"}`}>
                <div className="w-10 h-10 rounded-full bg-[#9D4EDD]/20 flex items-center justify-center shrink-0"><Icon size={18} className="text-[#D4AF37]" /></div>
                <div className="flex-1 min-w-0">
                  <p className="font-medium">{n.title}</p>
                  <p className="text-[#A19DB0] text-sm mt-0.5">{n.body}</p>
                  <p className="text-[#A19DB0]/60 text-xs mt-1">{fmtDateTime(n.created_at)}</p>
                </div>
                <ChevronRight size={18} className="text-[#A19DB0]/50 shrink-0" />
              </button>
            );
          })}
        </div>
      )}
    </Screen>
  );
}
